function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable import/prefer-default-export */
import { closestCorners, getFirstCollision, KeyboardCode } from '@dnd-kit/core';
import { getProjection } from "./utilities.js";
var DIRECTIONS = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
var HORIZONTAL = [KeyboardCode.Left, KeyboardCode.Right];
export function sortableTreeKeyboardCoordinates(context, indentationWidth) {
  return (event, _ref) => {
    var currentCoordinates = _ref.currentCoordinates,
      _ref$context = _ref.context,
      active = _ref$context.active,
      over = _ref$context.over,
      collisionRect = _ref$context.collisionRect,
      droppableRects = _ref$context.droppableRects,
      droppableContainers = _ref$context.droppableContainers;
    if (DIRECTIONS.includes(event.code)) {
      if (!active || !collisionRect) {
        return;
      }
      event.preventDefault();
      var _context$current = context.current,
        items = _context$current.items,
        offset = _context$current.offset;
      var projection = (over === null || over === void 0 ? void 0 : over.id) != null ? getProjection(items, active.id, over.id, offset, indentationWidth) : null;
      if (HORIZONTAL.includes(event.code) && (over === null || over === void 0 ? void 0 : over.id) != null && projection != null) {
        var depth = projection.depth,
          maxDepth = projection.maxDepth,
          minDepth = projection.minDepth;
        switch (event.code) {
          case KeyboardCode.Left:
            if (depth > minDepth) {
              return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
                x: currentCoordinates.x - indentationWidth
              });
            }
            break;
          case KeyboardCode.Right:
            if (depth < maxDepth) {
              return _objectSpread(_objectSpread({}, currentCoordinates), {}, {
                x: currentCoordinates.x + indentationWidth
              });
            }
            break;
        }
        return undefined;
      }
      var containers = [];
      droppableContainers.forEach(container => {
        if (container !== null && container !== void 0 && container.disabled || container.id === (over === null || over === void 0 ? void 0 : over.id)) {
          return;
        }
        var rect = droppableRects.get(container.id);
        if (!rect) {
          return;
        }
        switch (event.code) {
          case KeyboardCode.Down:
            if (collisionRect.top < rect.top) {
              containers.push(container);
            }
            break;
          case KeyboardCode.Up:
            if (collisionRect.top > rect.top) {
              containers.push(container);
            }
            break;
        }
      });
      var collisions = closestCorners({
        active,
        collisionRect,
        pointerCoordinates: null,
        droppableRects,
        droppableContainers: containers
      });
      var closestId = getFirstCollision(collisions, 'id');
      if (closestId === (over === null || over === void 0 ? void 0 : over.id) && collisions.length > 1) {
        closestId = collisions[1].id;
      }
      if (closestId != null && (over === null || over === void 0 ? void 0 : over.id) != null) {
        var activeRect = droppableRects.get(active.id);
        var newRect = droppableRects.get(closestId);
        var newDroppable = droppableContainers.get(closestId);
        if (activeRect && newRect && newDroppable) {
          var newIndex = items.findIndex(_ref2 => {
            var id = _ref2.id;
            return id === closestId;
          });
          var newItem = items[newIndex];
          var activeIndex = items.findIndex(_ref3 => {
            var id = _ref3.id;
            return id === active.id;
          });
          var activeItem = items[activeIndex];
          var closestProjection = getProjection(items, active.id, closestId, (newItem.depth - activeItem.depth) * indentationWidth, indentationWidth);
          if (newItem != null && activeItem != null && closestProjection != null) {
            var _depth = closestProjection.depth;
            var isBelow = newIndex > activeIndex;
            var modifier = isBelow ? 1 : -1;
            var newCoordinates = {
              x: newRect.left + _depth * indentationWidth,
              y: newRect.top + modifier
            };
            return newCoordinates;
          }
        }
      }
    }
    return undefined;
  };
}
//# sourceMappingURL=keyboardCoordinates.js.map